import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="xv-seccion xv-rsvp" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="xv-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="xv-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="xv-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="xv-boton xv-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="xv-boton-rsvp"
          >
            <Heart strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
